import { Component, OnInit, OnDestroy, ChangeDetectorRef , AfterViewInit, AfterContentChecked } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { QMManual } from '../models/qmmanual';
import { LU_QM_SourceReference } from '../models/luqmsourcereferencemodel';
import { LU_QM_SpecificationCategory} from '../models/luqmspecificationcategory';
import { LookupDataService } from '../services/lookup-data.service';
import { StarbaseNotificationService, StarbaseNotificationTypes } from 'starbase-notification';
import { StarbaseModalDialogService, StarbaseModalOptions, StarbaseModalButton, StarbaseModalTypes } from 'starbase-modal-dialog';
import { StarbaseLoginService, IUserTokenModel } from 'starbase-login';
import { FilterParams, TruncateString } from 'starbase-launcher';
import { ImageFile } from '../models/imageFile';
import { ActivatedRoute, Router  } from '@angular/router';
import { QMCategoryLink } from '../models/qmcategorylink';
import { isArray } from 'util';
import { AppComponent } from '../app.component';
import { PlatformLocation } from '@angular/common';
import { StarbaseComponentMessageService } from '../services/starbase-component-message.service';
import { GalleryTypeService } from '../services/gallery-type.service';
import { WebSocketService } from '../services/web-socket.service';

const LOADING_MESSAGE = 'Loading data...';

@Component({
  selector: 'app-quartermaster-manuals',
  templateUrl: './quartermaster-manuals.component.html',
  styleUrls: ['./quartermaster-manuals.component.css']
})
export class QuartermasterManualComponent implements OnInit, OnDestroy, AfterViewInit, AfterContentChecked {
    public data: QMManual[] = [];
    public filter: FilterParams<QMManual>;
    public sourceReferences: LU_QM_SourceReference[] = [];
    public specificationCategories: LU_QM_SpecificationCategory[] = [];
    public listMode = true;
    public addMode = false;
    public viewSingle = false;
    public isAdmin = false;
    public loggedInUser: IUserTokenModel = null;
    public isLoading = false;
    public refSearching = false;
    public stateSet = false;
    public model = new QMManual();
    public viewModel: QMManual;
    public expanded = false;
    public sortStates: object[];
    public relatedImages: ImageFile[];
    relatedImagesPage = 1;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    public RTFHeight = '250px';
    // SORTING
    public itemNameSortDirection = 0;
    public specificationSortDirection = 0;
    public sourceReferenceSortDirection = 0;
    public specificationCategorySortDirection = 0;

    // PAGINATION
    public itemsPerPage = 10;
    public currentPage = 0;
    public pageNumber = 1;
    public maxPage = 0;
    public startIndex = 0;
    public endIndex = 10;
    public allItemsCount = 0;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    public CONTRACTED_HEIGHT = 55;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    public EXPANDED_HEIGHT = 200;
    public nextBtn: HTMLElement;
    public lastBtn: HTMLElement;
    public prevBtn: HTMLElement;
    public firstBtn: HTMLElement;
    // TODO: ^ We can probably move all pagination responsibilities to the Starbase-Pagination-Component.

    public rtfViewTools = {
        items: [  ]
    };

    public tools = AppComponent.rtfTools;
    public backQueue: number[] = [];

    public size = AppComponent.rtfSize;
    public fontFamilies = AppComponent.rtfFontFamilies;

    truncateString = TruncateString;

    dataLoadSubscription: Subscription;

    public searchQMTerm = '';
    private searchCopy = '';
    private createQMSubscriber: Subscription;
    private qmUpdatedSubscription: Subscription;
    constructor(private lookupSvc: LookupDataService,
                private modalSvc: StarbaseModalDialogService,
                private notificationSvc: StarbaseNotificationService,
                private loginSvc: StarbaseLoginService,
                private cdr: ChangeDetectorRef,
                private route: ActivatedRoute,
                private router: Router,
                private appComponent: AppComponent,
                private location: PlatformLocation,
                public sbCmpMsg: StarbaseComponentMessageService,
                private galleryTypeSvc: GalleryTypeService,
                private webSocketSvc: WebSocketService) {

        // history.pushState(null, null, window.location.href);
        // this.location.onPopState(() => {
        //     history.pushState(null, null, window.location.href);
        //     this.cancelAndGoBack();
        // });

        this.isAdmin = this.loginSvc.getUserModel().isAdmin();
        this.loggedInUser = this.loginSvc.getUserModel();
        this.initializeModel();

        this.location.onPopState(() => {
          if (this.viewSingle || this.addMode) {
            this.cancelAndGoBack();
          } else if (this.stateSet) {
            this.location.back();
          }
        });

        this.galleryTypeSvc.clearLibraryRelatedSetImages();
    }

    public get isTrialUser(): boolean {
      return !this.isAdmin && !this.loggedInUser.isInUserGroup('Librarian') && !this.loggedInUser.isInUserGroup('Subscriber');
    }

    public get canEdit(): boolean {
      return this.isAdmin || this.loggedInUser.isInUserGroup('Librarian');
    }
    // onSelected(value): void{
    //     this.itemsPerPage = value;
    // }
    calculatePaginationIndices() {
        this.currentPage = 0;
        this.filter.page = 1;
        this.pageNumber = 1;
        this.calculateTotalPages();
        this.calculateIndices();
    }

    ngAfterContentChecked() {
        this.cdr.detectChanges();
    }

    initializeFilter() {
      this.filter = new FilterParams<QMManual>();
      this.filter.rpp = 10;
      this.filter.page = 1;
    }

    calculateIndices() {
        this.startIndex = this.currentPage * this.itemsPerPage;
        this.endIndex = (this.currentPage + 1) * this.itemsPerPage;
    }

    calculateTotalPages() {
        if (this.allItemsCount < this.itemsPerPage) {
            this.maxPage = 0;
        } else {
           this.maxPage = Math.floor(this.allItemsCount / this.itemsPerPage);

            if (this.allItemsCount % this.itemsPerPage === 0) {
                this.maxPage--;
            }

        }

        this.disablingOperations();
    }

    removeAllDisabling() {
        this.nextBtn.classList.remove('icon_disabled'); // TODO: look into these calls. Doubtful they are needed this way.
        this.lastBtn.classList.remove('icon_disabled');
        this.prevBtn.classList.remove('icon_disabled');
        this.firstBtn.classList.remove('icon_disabled');
    }

    lastButtonOptionalDisabling() {
        if (this.data.length !== this.allItemsCount) {
           this.lastBtn.classList.add('icon_disabled');
        }
    }

    disablingOperations() {
        this.removeAllDisabling();
        if (this.maxPage > 0) {
            this.firstBtn.classList.add('icon_disabled');
            this.prevBtn.classList.add('icon_disabled');
        } else {
            this.nextBtn.classList.add('icon_disabled');
            this.prevBtn.classList.add('icon_disabled');
            this.firstBtn.classList.add('icon_disabled');
        }

        this.lastButtonOptionalDisabling();
    }

    movePage(step: number) {
        let calculated = false;
        if (step > 0) {
            if (this.currentPage < this.maxPage) {

                if (step === 1) {
                    this.currentPage++;
                    this.filter.page++;
                } else if (step === 1000) {
                    // if (this.data.length !== this.allItemsCount) {
                      //  return;
                    // }
                    this.currentPage = this.maxPage;
                    this.filter.page = this.filter.totalPages;
                }

                this.removeAllDisabling();
                if (this.currentPage === this.maxPage) {
                    this.nextBtn.classList.add('icon_disabled');
                    this.lastBtn.classList.add('icon_disabled');
                }

                this.lastButtonOptionalDisabling();


                calculated = true;
            }
        } else if (step < 0) {
            if (this.currentPage > 0) {

                if (step === -1) {
                    this.currentPage--;
                    this.filter.page--;
                } else if (step === -1000) {
                    this.currentPage = 0;
                    this.filter.page = 1;
                }

                this.removeAllDisabling();
                if (this.currentPage === 0) {
                    this.prevBtn.classList.add('icon_disabled');
                    this.firstBtn.classList.add('icon_disabled');
                }

                calculated = true;
            }
        }

        if (calculated) {
            this.pageNumber = this.currentPage + 1;
            this.calculateIndices();
            this.retrieve();
        }
    }

    public handleRTFActions(event: any) {

    }

    handleRTFChanges(event: any) {

    }

    retrieve(secondField = '', setIndex = 0) {
        // if (this.data.length < this.allItemsCount) {
           this.loadingSpinner('inline-block');

            let sortBy = '0';
            let isDescending = false;
            if (this.itemNameSortDirection !== 0) {
                sortBy = 'ItemName';

                if (this.itemNameSortDirection === -1) {
                    isDescending = true;
                }
            }

            if (this.specificationSortDirection !== 0) {
                sortBy = 'Specification';

                if (this.specificationSortDirection === -1) {
                    isDescending = true;
                }
            }

            if (this.specificationCategorySortDirection !== 0) {
                sortBy = 'SpecificationCategoryUID';

                if (this.specificationCategorySortDirection === -1) {
                    isDescending = true;
                }
            }

            if (this.sourceReferenceSortDirection !== 0) {
                sortBy = 'SourceReference.SourceReference';

                if (this.sourceReferenceSortDirection === -1) {
                    isDescending = true;
                }
            }

            if (!this.isEmpty(secondField) && !this.isEmpty(sortBy)) {
                sortBy += ',' + secondField;
            }
            this.filter.rpp = this.itemsPerPage;
            this.filter.page = this.pageNumber;
            this.loadData(false, () => {
                this.loadingSpinner('none');
                if (setIndex > 0) {
                  this.viewModel = Object.assign(new QMManual(), this.data[setIndex]);
                  this.getRelatedImagesToQMManual(this.viewModel.uid);
                  this.location.replaceState(
                    this.location.getState(),
                    '',
                    '/quartermaster-manuals/' + this.viewModel.uid
                  );
                }
            }, sortBy, isDescending);
        // }
    }

    loadingSpinner(display: string) {
        const gifElement = document.getElementById('searchWait');
        if (gifElement) {
            gifElement.style.display = display;
        }
    }

    isEmpty(str: string) {
        if (str) {
            str = str.trim();

            return str.length === 0;
        }

        return true;
    }

    isInCurrentPage(uid: number) {
        const item = this.data.find(x => x.uid === uid);

        // eslint-disable-next-line eqeqeq
        return item['page'] == this.pageNumber;
    }

    addToDataArray(newArray: QMManual[], pageNumber = -1) {
        newArray.forEach(obj => {
            const item = this.data.find(x => x.uid === obj.uid);

            if (item === undefined) {

                if (pageNumber !== -1) {
                    obj.page = pageNumber;
                } else {
                    obj.page = this.maxPage + 1;
                }

                obj.saniSpecifications = AppComponent.removeMarkupFromString(obj.specifications);
                this.data.push(obj);
            } else {

                // eslint-disable-next-line eqeqeq
                if (pageNumber != -1) {
                    item.page = pageNumber;
                } else {
                    item.page = this.maxPage + 1;
                }

            }
        });
    }

    updateItemInDataArray(newItem: any) {
        for (let i = 0; i < this.data.length; i++) {
            if (this.data[i].uid === newItem.uid) {
                const manual = Object.assign(new QMManual(), newItem);
                manual.page = this.data[i].page;
                this.data[i] = manual;
            }
        }
    }

    loadData(doPaginationOperations: boolean = true, callback?: any, sortby = '0', sortDescending = false) {
        this.filter.sortAsc = !sortDescending;

        if (sortby !== '0') {
            this.filter.sortFields = sortby.split(',');
        }

        this.isLoading = true;
        this.dataLoadSubscription = this.lookupSvc.postRequisiteData(
          this.lookupSvc.QuartermasterURL + '/GetPaginatedQmSpecs',
          this.filter).subscribe((result: FilterParams<QMManual>) => {
            this.filter = result;
            if (result.page === 1 && sortby !== '0') {
                // WE CLEAR THE DATA
                this.data = [];
            }

            this.addToDataArray(result.collection, result.page);
            this.allItemsCount = result.totalRecords;
            this.isLoading = false;

            if (doPaginationOperations) {
                this.calculatePaginationIndices();
            }

            if (callback) {
                callback();
            }
        }, () => {
            this.notificationSvc.postNotification(
              this.notificationSvc.notificationBuilder(
                'Error',
                'Could not retrieve information from server',
                StarbaseNotificationTypes.Error
              )
            );
        });
    }

    getSourceReferenceName(uid: number) {
        const result = this.sourceReferences.find(x => x.uid === uid);

        if (result) {
            return result.sourceReference;
        }

        return '';
    }

    addCategories(item: any[]) {
        if (item && isArray(item)) {
            this.model.specificationCategoryUIDs = [];
            item.forEach(categoryUid => {
                const thisItem  = this.model.specificationCategoryUIDs.find(x => x.specificationCategoryUID === categoryUid);

                if (thisItem === null || thisItem === undefined) {
                    const link = new QMCategoryLink();
                    link.specificationCategoryUID = Number(categoryUid);
                    link.qM_ManualModelUID = this.model.uid;
                    this.model.specificationCategoryUIDs.push(link);
                }
            });
        }
    }

    setSourceReference(item: any[]) {
        if (item && item.length) {
            this.model.sourceReferenceUID = item[0];
        }
    }


    removeCategory(uid: number) {
        for (let i = 0; i < this.model.specificationCategoryUIDs.length; i++) {
            if (this.model.specificationCategoryUIDs[i].specificationCategoryUID === uid) {
                this.model.specificationCategoryUIDs.splice(i, 1);
                break;
            }
        }
    }

    getCategoriesArray(isEditing = false) {
        const array = [];

        if (isEditing) {
            if (this.model.specificationCategoryUIDs && this.model.specificationCategoryUIDs.length) {
                this.model.specificationCategoryUIDs.forEach(obj => {
                    array.push({
                      specificationCategoryUID: obj.specificationCategoryUID,
                      specificationCategory: this.getSpecificationCategory(obj.specificationCategoryUID)
                    });
                });

                this.sortArray(array, 'specificationCategory');
            }
        } else {
            if (this.viewModel.specificationCategoryUIDs && this.viewModel.specificationCategoryUIDs.length) {
                this.viewModel.specificationCategoryUIDs.forEach(obj => {
                    array.push({ specificationCategoryUID: obj.specificationCategoryUID,
                                 specificationCategory: this.getSpecificationCategory(obj.specificationCategoryUID),
                                 createdByUser: obj.createdByUser,
                                 createdDateTime: obj.createdDateTime });
                });

                this.sortArray(array, 'specificationCategory');
            }
        }

        return array;
    }

    getCategoryArrayForEdit() {
        const array = [];
        this.model.specificationCategoryUIDs.forEach(obj => {
            array.push(obj.specificationCategoryUID);
        });

        return array;
    }

    getSpecificationCategory(uid: any) {
        const getCatname = (uidn) => {
            const result = this.specificationCategories.find(x => x.uid === uidn);

            if (result) {
               return result.specificationCategory;
            }

           return '';
        };

        if (typeof uid === 'number') {
            return getCatname(uid);
        } else if (isArray(uid)) {
            let list = '';
            uid.forEach(obj => {
                const thisItem = getCatname(obj['specificationCategoryUID']);

                if (list !== '') {
                    list += ', ';
                }

                list += thisItem;
            });

            return list;
        }
    }

    addToRefList(item: QMManual) {
        if (this.model.uid !== 0 && item.uid === this.model.uid) {
            return;
        }

        this.addToDataArray([item]);
        const uid = item.uid;

        const existing = this.model.qM_Links.find(x => x['qM_RefUID'] === uid);

        if (existing) {
            return;
        }

        if (this.model.uid === 0) {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            this.model.qM_Links.push({qM_RefUID: uid, qM_Ref: item});
        } else {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            this.model.qM_Links.push({qM_RefUID: uid, qM_SrcUID: this.model.uid, qM_Ref: item});
        }
    }

    getRefName(uid: number) {
        const lobj = this.data.find(x => x.uid === uid);

        if (lobj) {
            return lobj.itemName;
        } else {
            if (this.refSearching) {
                return '';
            }

            // THERE MIGHT BE CONCURRENT SEARCHES SO IMPLEMENTING A QUICK SEMAPHORE SYSTEM
            this.refSearching = true;
            this.lookupSvc.getRequisiteData(this.lookupSvc.QuartermasterURL + '/' +  uid).subscribe((result: QMManual) => {
                this.addToDataArray([result]);
                return result.itemName;
            }, () => {

            }, () => {
                this.refSearching = false;
            });
        }
    }

    removeQMSpecRef(qmManual: QMManual) {
        let i = 0;
        const uid = qmManual.uid;
        for (let j = 0; j < this.model.qM_Links.length; j++) {
            if ( (this.model.qM_Links[j]['qM_RefUID'] !== this.model.uid && this.model.qM_Links[j]['qM_RefUID'] === uid) ||
                 (this.model.qM_Links[j]['qM_SrcUID'] !== this.model.uid && this.model.qM_Links[j]['qM_SrcUID'] === uid)
               ) {
                i = j;
                break;
            }
        }

        this.model.qM_Links.splice(i, 1);
    }

    sortArray(array: any[], property: string, descending: boolean = false, secondField?: string) {
        array.sort((a, b) => {
            if (a[property] > b[property]) {
                if (!descending) {
                    return 1;
                } else {
                    return -1;
                }
            } else if (a[property] < b[property]) {
                if (!descending) {
                    return -1;
                } else {
                    return 1;
                }
            } else if (a[property] === b[property] && secondField) {
                if (a[secondField] > b[secondField]) {
                    return 1;
                } else {
                    return -1;
                }
            }
        });
    }

    sortClick(field: string) {
        let isDescending: boolean;
        let secondField = '';
        switch (field) {
            case 'itemName': {
                this.itemNameSortDirection = (this.itemNameSortDirection === 0 ? 1 : (this.itemNameSortDirection === 1 ? -1 : 1));
                isDescending = (this.itemNameSortDirection === -1 ? true : false);
                this.specificationCategorySortDirection = this.sourceReferenceSortDirection = this.specificationSortDirection = 0;
                secondField = '';
            } break;
            case 'specification': {
                // eslint-disable-next-line max-len
                this.specificationSortDirection = (this.specificationSortDirection === 0 ? 1 : (this.specificationSortDirection === 1 ? -1 : 1));
                isDescending = (this.specificationSortDirection === -1 ? true : false);
                this.specificationCategorySortDirection = this.sourceReferenceSortDirection = this.itemNameSortDirection = 0;
                secondField = '';
            } break;
            case 'sourceReference' : {
                // eslint-disable-next-line max-len
                this.sourceReferenceSortDirection = (this.sourceReferenceSortDirection === 0 ? 1 : (this.sourceReferenceSortDirection === 1 ? -1 : 1));
                isDescending = (this.sourceReferenceSortDirection === -1 ? true : false);
                this.specificationCategorySortDirection = this.specificationSortDirection = this.itemNameSortDirection = 0;
                secondField = 'itemName';
            } break;
            case 'specificationCategoryUID': {
                // eslint-disable-next-line max-len
                this.specificationCategorySortDirection = (this.specificationCategorySortDirection === 0 ? 1 : (this.specificationCategorySortDirection === 1 ? -1 : 1));
                isDescending = (this.specificationCategorySortDirection === -1 ? true : false);
                this.sourceReferenceSortDirection = this.specificationSortDirection = this.itemNameSortDirection = 0;
                secondField = 'itemName';
            } break;
        }


        this.currentPage = 0;
        this.filter.page = 1;
        this.pageNumber = 1;
        this.retrieve(secondField);

        /*if (this.data.length === this.allItemsCount) { // WE DO A LOCAL SORT
            this.sortArray(this.data, field, isDescending, secondField);
        } else { // WE DO A SERVER SORT
            this.currentPage = 0;
            this.retrieve(secondField);
        }*/
    }

    ngAfterViewInit() {
      this.initializeFilter();
      this.tools['type'] = 'MultiRow';
      this.loadingSpinner('inline-block');
      this.loadData(true, () => {
        this.loadingSpinner('none');
        const id = +this.route.snapshot.paramMap.get('id');
        if (id !== null && id !== 0) {
          this.enterViewMode(id, false);
        }
      });
      this.getAllButtons();
    }

    getAllButtons() {
        this.nextBtn = document.getElementById('goToNextPage');
        this.lastBtn = document.getElementById('goToLastPage');
        this.prevBtn = document.getElementById('goToPreviousPage');
        this.firstBtn = document.getElementById('goToFirstPage');
    }

    ngOnInit() {
        // eslint-disable-next-line max-len
        this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData(this.lookupSvc.getLUQmSourceReferenceUrl).subscribe((sourceReferences: LU_QM_SourceReference[]) => {
            this.sourceReferences = sourceReferences;
            this.sortArray(this.sourceReferences, 'sourceReference');

        }, () => {
            this.notificationSvc.postNotification(
              this.notificationSvc.notificationBuilder(
                'Error',
                'Could not retrieve information from server',
                StarbaseNotificationTypes.Error
              )
            );
        });

        // eslint-disable-next-line max-len
        this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData(this.lookupSvc.getLUSpecificationCategoryUrl).subscribe((specificationCategories: LU_QM_SpecificationCategory[]) => {
            this.specificationCategories = specificationCategories;
            this.sortArray(this.specificationCategories, 'specificationCategory');
        }, () => {
            this.notificationSvc.postNotification(
              this.notificationSvc.notificationBuilder(
                'Error',
                'Could not retrieve information from server',
                StarbaseNotificationTypes.Error
              )
            );
        });

        this.qmUpdatedSubscription = this.webSocketSvc.imageUpdatedTrigger$.subscribe(
          (data) => {
            const recordUid = data[0];
            const user = data[1];
            if (recordUid === this.model.uid  && user !== this.loggedInUser.user && this.addMode) {
              this.enableUpdateModal(
                // eslint-disable-next-line max-len
                'This Record has been updated by another user. Please copy or make note of any changes then click "Continue" to load the latest version.',
                'Continue'
              ).subscribe(
                () => {
                  this.enterViewMode(this.model.uid);
                }
              );
            } else if (recordUid === this.viewModel.uid && user !== this.loggedInUser.user && !this.isTrialUser && this.viewSingle) {
              this.notificationSvc.postNotification(
                this.notificationSvc.notificationBuilder(
                  'QM Record Updated',
                  'This Record has been updated by another user.',
                  StarbaseNotificationTypes.Info
                )
              );
              this.enterViewMode(this.model.uid, true);
            }
          }
        );

        this.webSocketSvc.setupQMConnection();
    }

    getRefQMArrays(isEditing = false) {
        let nArray = [];

        if (!isEditing) {
            if (this.viewModel.qM_Links && this.viewModel.qM_Links.length) {
                nArray = this.viewModel.qM_Links.map(obj => {
                    let qm = obj['qM_Ref'] as QMManual;

                    if (!qm  || (qm && qm.uid === this.viewModel.uid)) {
                        qm = obj['qM_Src'] as QMManual;
                    }

                    if (qm) {
                        qm['createdByUser'] = (obj['createdByUser'] ? obj['createdByUser'] : '');
                        qm['createdDateTime'] = (obj['createdDateTime'] ? obj['createdDateTime'] : '');
                        return qm;
                    }
                });
            }
        } else {
            if (this.model && this.model.qM_Links && this.model.qM_Links.length) {
                nArray = this.model.qM_Links.map(obj => {
                    let qm = obj['qM_Ref'] as QMManual;

                    if (!qm || (qm && qm.uid === this.model.uid)) {
                        qm = obj['qM_Src'] as QMManual;
                    }

                    return qm;
                });
            }
        }

        return nArray;
    }

    addEntryActivate(clearViewModel = false) {
        this.listMode = this.viewSingle = false;
        this.addMode = true;

        if (clearViewModel && this.viewModel) {
            this.viewModel.qM_Links = null;
            this.viewModel.specificationCategoryUIDs = [];
        }

        this.initializeModel();
    }

    initializeModel() {
        this.model.itemName = this.model.specifications = '';
        this.model.qM_Links = [];
        this.model.uid = this.model.sourceReferenceUID = 0;
        this.model.specificationCategoryUIDs = [];
    }

    move(isBackward = false) {
        let currentItemIndex = this.data.findIndex(x => x.uid === this.viewModel.uid);

        if (currentItemIndex !== -1) {
            if (!isBackward) {
              currentItemIndex++;
              if (currentItemIndex >= this.data.length) {
                this.currentPage++;
                this.filter.page++;

                this.removeAllDisabling();
                if (this.currentPage === this.maxPage) {
                  this.nextBtn.classList.add('icon_disabled');
                  this.lastBtn.classList.add('icon_disabled');
                }

                this.lastButtonOptionalDisabling();

                this.pageNumber = this.currentPage + 1;
                this.calculateIndices();
                this.retrieve('', currentItemIndex);
              } else {
                this.viewModel = Object.assign(new QMManual(), this.data[currentItemIndex]);
                this.getRelatedImagesToQMManual(this.viewModel.uid);
                this.location.replaceState(
                  this.location.getState(),
                  '',
                  '/quartermaster-manuals/' + this.viewModel.uid
                );
              }

            } else {
              currentItemIndex--;

              this.viewModel = Object.assign(new QMManual(), this.data[currentItemIndex]);
              this.getRelatedImagesToQMManual(this.viewModel.uid);
              this.location.replaceState(
                this.location.getState(),
                '',
                '/quartermaster-manuals/' + this.viewModel.uid
              );
            }
        }
    }

    enterEditMode(uid: number) {
        this.addEntryActivate();
        const c  = this.data.find(x => x.uid === Number(uid));
        if (c) {
           this.model.uid = c.uid;
           this.model.itemName = c.itemName;
           this.model.specifications = c.specifications;
           this.model.specificationCategoryUIDs = [];
           this.model.qM_Links = [];
           this.model.sourceReferenceUID = c.sourceReferenceUID;

           if (c.qM_Links && c.qM_Links.length) {
                c.qM_Links.forEach(obj => {
                    if (obj['qM_RefUID'] !== c.uid) {
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        this.model.qM_Links.push({qM_RefUID: obj['qM_RefUID'] , qM_SrcUID: obj['qM_SrcUID'], qM_Ref: obj['qM_Ref']});
                    } else {
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        this.model.qM_Links.push({qM_RefUID: obj['qM_RefUID'] , qM_SrcUID: obj['qM_SrcUID'], qM_Src: obj['qM_Src']});
                    }
                });
           }

           if (c.specificationCategoryUIDs && c.specificationCategoryUIDs.length) {
               c.specificationCategoryUIDs.forEach(obj => {
                   this.model.specificationCategoryUIDs.push(obj);
               });
           }
        }
    }

    isSaveable() {
        if (this.model.uid === 0) {
            // eslint-disable-next-line max-len
            return !this.isEmpty(this.model.itemName) && !this.isEmpty(this.model.specifications) && this.model.sourceReferenceUID !== 0 && this.model.specificationCategoryUIDs.length > 0;
        } else {
            return true;
        }
    }

    saveQMSpecification() {
        // eslint-disable-next-line max-len
        if (!this.model.itemName || !this.model.specifications || this.model.sourceReferenceUID === 0 || this.model.specificationCategoryUIDs.length === 0) {
            window.scroll(0, 0);
            this.notificationSvc.postNotification(
              this.notificationSvc.notificationBuilder(
                'Error',
                'Please enter all required fields',
                StarbaseNotificationTypes.Error
              )
            );
            return;
        }

        this.isLoading = true;
        let result: any = 0;
        let isInsert = false;

        const nmod = (JSON.parse(JSON.stringify(this.model)));
        if (nmod.qM_Links && nmod.qM_Links.length) {
            for (let i = 0; i < nmod.qM_Links.length; i++) {
                nmod.qM_Links[i]['qM_Ref'] = nmod.qM_Links[i]['qM_Src'] = null;
            }
        }

        if (this.model.uid === 0) {
            isInsert = true;
            result = this.lookupSvc.postRequisiteData<QMManual>(this.lookupSvc.QuartermasterURL,  nmod);
        } else {
            result = this.lookupSvc.putRequisiteData(this.lookupSvc.QuartermasterURL + '/', String(nmod.uid), nmod);
        }

        this.createQMSubscriber = result.subscribe((obj: QMManual[]) => {
            this.notificationSvc.postNotification(
              this.notificationSvc.notificationBuilder(
                'Success',
                'Information saved successfully!',
                StarbaseNotificationTypes.Success
              )
            );
            this.isLoading = false;
            let firstIndex = 0;
            if (isInsert) {
                // JUST INSERT THE FIRST ONE
                this.addToDataArray([obj[0]]);
                this.allItemsCount++;
                firstIndex = 1;
                this.relatedImages = [];
            }

            for (let i = firstIndex; i < obj.length; i++) {
                const thisIndex = this.data.findIndex(x => x.uid === obj[i].uid);

                if (thisIndex != null && thisIndex !== undefined) {
                    obj[i]['saniSpecifications'] = AppComponent.removeMarkupFromString(obj[i].specifications);
                    obj[i]['page'] = this.pageNumber;
                    this.data[thisIndex] = obj[i];
                }
            }


            this.listMode = this.addMode = false;
            this.viewModel = Object.assign(new QMManual(), obj[0]);
            this.viewSingle = true;

        }, () => {
            this.notificationSvc.postNotification(
              this.notificationSvc.notificationBuilder(
                'Error',
                'Could not save information to server',
                StarbaseNotificationTypes.Error
              )
            );
            this.isLoading = false;
        });
    }

    cancelAndGoBack() {
        if (this.backQueue.length > 0) {
            const lastItem = this.backQueue.pop();
            this.enterViewMode(lastItem, false, true);
        } else {
            this.listActivate();
            setTimeout(() => {
                this.searchQMTerm = this.searchCopy;
                this.getAllButtons();
                this.lastButtonOptionalDisabling();
                if (this.currentPage === 0) {
                    this.disablingOperations();
                }
            } , 500);
        }
    }

    backToViewMode() {
        this.viewSingle = true;
        this.listMode = this.addMode = false;
    }

    listActivate() {
        this.listMode = true;
        this.addMode = this.viewSingle = false;
    }

    getRelatedImagesToQMManual(qmid: number) {
      this.relatedImages = [];

      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      this.lookupSvc.getRelatedImagesForQMSpec(qmid).subscribe(a => {
        this.relatedImages = a;
        this.galleryTypeSvc.setLibraryImages(this.relatedImages);
        this.isLoading = false;
      }, () => {
        this.isLoading = false;
      });
    }

    getRelatedImagesNextPage() {
      if (this.isLoading) {
        return;
      }

      this.lookupSvc.getRelatedImagesForQMSpec(this.viewModel.uid, ++this.relatedImagesPage).subscribe(a => {
        this.relatedImages = [...this.relatedImages, ...a];
        this.galleryTypeSvc.setLibraryImages(this.relatedImages);
        this.isLoading = false;
      }, () => {
        this.isLoading = false;
      });
    }

    //goToImage(imgId: number) {
    //    this.router.navigate(['/imageSingleView/' + imgId + '/' + this.viewModel.uid]);
    //}

    goToImage(data) {
      const e = this.relatedImages.find(x => x.uid === data.uid);
      this.galleryTypeSvc.setLastSelectedRecord(e);
      this.galleryTypeSvc.setLastViewedRecordRelatedSetStatus(false);
      this.router.navigate(['imageSingleView', e.uid, this.viewModel.uid]);
    }

    afterConfirmViewMode(litem: any, isBack = false) {

      if (this.isTrialUser) {
        this.viewModel = new QMManual();
        this.viewModel.itemName = 'Burnt Coffee';
        this.viewModel.specifications = 'Leave the bag of grinds in the pot, and wait to see what happens.';
        this.listMode = this.addMode = false;
        this.viewSingle = true;
        this.appComponent.showSubscribeMessage();
        return;
      }

        const paramType = typeof litem;
        let qmid = 0;

        if (paramType === 'object') {
            this.addToDataArray([litem]);
            qmid = litem.uid;
        } else {
            qmid = litem;
        }

        const item = this.data.find(x => x.uid === qmid);
        const url = this.lookupSvc.QuartermasterURL + '/' + qmid;

        // IF WE ARE NOT IN LIST MODE AND IT IS NOT LOADING FROM PRESSING THE BACK BUTTON, WE ADD TO THE BACK QUEUE
        if (!this.listMode && !isBack) {
            this.backQueue.push(this.viewModel.uid);
        }

        if (item !== undefined) {
            if (!item.qM_Links) {
                this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData(url).subscribe((qMManual: object) => {
                    this.updateItemInDataArray(qMManual);
                    this.viewModel = Object.assign(new QMManual(), qMManual);
                }, () => {
                  this.notificationSvc.postNotification(
                    this.notificationSvc.notificationBuilder(
                      'Error',
                      'Could not find selected Quartermaster Manual',
                      StarbaseNotificationTypes.Error
                    )
                  );
                });
            }

            this.listMode = this.addMode = false;
            this.viewModel = Object.assign({}, item);
            this.viewSingle = true;
            this.getRelatedImagesToQMManual(qmid);
            this.location.replaceState(
              this.location.getState(),
              '',
              '/quartermaster-manuals/' + qmid
            );
        } else {
            this.dataLoadSubscription = this.lookupSvc.getAllRequisiteData(url).subscribe((qMManual: object) => {
                this.addToDataArray([qMManual as QMManual]);
                this.viewModel = Object.assign(new QMManual(), qMManual);
                this.listMode = this.addMode = false;
                this.viewSingle = true;
                this.getRelatedImagesToQMManual(qmid);
                this.location.replaceState(
                  this.location.getState(),
                  '',
                  '/quartermaster-manuals/' + qmid
                );
            }, () => {
                this.notificationSvc.postNotification(this.notificationSvc.notificationBuilder('Error',
                                                                                            'Could not find selected Quartermaster Manual',
                                                                                            StarbaseNotificationTypes.Error));
            });

        }
    }

    enterViewMode(litem: any, wasEditingOrAdding?: boolean, isBack?: boolean) {

        if (wasEditingOrAdding) {
            let changesEntered = false;

            if (this.model.uid === 0) {
                if (this.model.itemName !== '' || this.model.specifications !== '' || this.model.qM_Links.length ||
                this.model.specificationCategoryUIDs.length !== 0 || this.model.sourceReferenceUID !== 0) {
                    changesEntered = true;
                }
            } else {
                const original  = this.data.find(x => x.uid === this.model.uid);

                if (this.model.itemName !== original.itemName || this.model.specifications !== original.specifications ||
                    this.model.sourceReferenceUID !== original.sourceReferenceUID ||
                    this.model.specificationCategoryUIDs.length !== original.specificationCategoryUIDs.length) {
                        changesEntered = true;
                }
            }

            if (changesEntered) {
                this.enableConfirmRowModal('Are you sure you want to exit? Your changes will be lost.',
                                    'Changes rolled back',
                                    'User did not leave screen').subscribe(a => {
                    if (a) {
                        if (this.model.uid !== 0) {
                            this.afterConfirmViewMode(litem, isBack);
                        } else {
                            this.listActivate();
                        }
                    }
                });
            } else {
                if (this.model.uid !== 0) {
                    this.afterConfirmViewMode(litem, isBack);
                } else {
                    this.listActivate();
                }
            }
        } else {
            if (!this.stateSet) {
              this.location.pushState(null, 'QM Spec', window.location.href);
            }
            this.afterConfirmViewMode(litem, isBack);
        }
    }

    expandRetractRelatedImages() {
        const element = document.getElementById('relatedImagesDiv');
        const icon = document.getElementById('icone');
        let interval;
        const step = 10;
        const intervalMs = 20;
        let currentHeight: number;

        // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
        function postInterval() {
            element.style.height = currentHeight + 'px';
            clearInterval(interval);
        }

        if (!this.expanded) {
            currentHeight = this.CONTRACTED_HEIGHT;
            interval = setInterval(() => {
                currentHeight += step;
                element.style.height = currentHeight + 'px';

                if (currentHeight >= this.EXPANDED_HEIGHT ) {
                    currentHeight = this.EXPANDED_HEIGHT;
                    this.expanded = true;
                    icon.classList.remove('fa-sort-up');
                    icon.classList.add('fa-sort-down');
                    icon.style.top = '0px';
                    postInterval();
                }
            }, intervalMs);
        } else {
            currentHeight = this.EXPANDED_HEIGHT;
            interval = setInterval(() => {
                currentHeight -= step;
                element.style.height = currentHeight + 'px';

                if (currentHeight <= this.CONTRACTED_HEIGHT) {
                    currentHeight = this.CONTRACTED_HEIGHT;
                    this.expanded = false;
                    icon.classList.remove('fa-sort-down');
                    icon.classList.add('fa-sort-up');
                    icon.style.top = '6px';
                    postInterval();
                }
            }, intervalMs);
        }
    }

    getHistoryThumbnails(): ImageFile[] {
        return [];
    }

    deleteQM(uid: string) {

        if (this.relatedImages && this.relatedImages.length > 0) {
            this.notificationSvc.postNotification(
              this.notificationSvc.notificationBuilder(
                'Message',
                'Quartermaster Specifications related to one or more images can\'t be deleted.',
                StarbaseNotificationTypes.Info
              )
            );
            return;
        }

        this.enableConfirmRowModal('Are you sure you want to delete this quartermaster specification? This operation can\'t be undone.',
                                   'User Deleted Row',
                                   'User did not delete row').subscribe(a => {
            if (a === true) {
                this.lookupSvc.deleteData(this.lookupSvc.QuartermasterURL + '/', uid).subscribe(() => {


                    for (let i = 0; i < this.data.length; i++) {
                        if (this.data[i].uid === Number(uid)) {
                            this.data.splice(i, 1);
                            this.allItemsCount--;
                            break;
                        }
                    }
                    this.cancelAndGoBack();
                    this.notificationSvc.postNotification(
                      this.notificationSvc.notificationBuilder(
                        'Success',
                        'Information deleted successfully',
                        StarbaseNotificationTypes.Success
                      )
                    );
                }, () => {
                    this.notificationSvc.postNotification(
                      this.notificationSvc.notificationBuilder(
                        'Error',
                        'Could not delete information',
                        StarbaseNotificationTypes.Error
                      )
                    );
                });
            }
        });
    }

    enableConfirmRowModal(msg: string, successmsg?: string, errormsg?: string): Observable<boolean> {
        const m = new Observable<boolean>(obj => {
            const modal = new StarbaseModalOptions('Confirm', msg, [
                new StarbaseModalButton('Yes', () => {
                    obj.next(true);
                    this.modalSvc.closeModal(successmsg);
                }),
                new StarbaseModalButton('No', () => {
                    obj.next(false);
                    this.modalSvc.closeModal(errormsg);
                }),
            ], StarbaseModalTypes.Warning);
            modal.dismissable = true;
            this.modalSvc.postModal(modal);
        });

        return m;
    }

  quickFilterData(item: string): void {
    this.isLoading = true;
    this.searchCopy = item;
    // TODO: SPECIFY THE STRING MODEL ON THE WAY BACK
    if (item === '') {
        this.currentPage = 0;
        this.filter.page = 1;
        this.pageNumber = 1;
        this.data = [];
        this.loadingSpinner('inline-block');
        this.loadData(true, () => {
            this.loadingSpinner('none');
        });
    }
  }

  searchDataResults(results: QMManual[]): void {
    try {
        // WE MOVE TO FIRST PAGE
        this.movePage(-1000);
        results = results.map(a => new QMManual().deserialize(a));
        results.forEach(obj => {
          obj['page'] = this.pageNumber;
          obj['saniSpecifications'] = AppComponent.removeMarkupFromString(obj.specifications);
        });
        this.data = results;
        this.allItemsCount = results.length;
        if (!results.length) {
            const a = new QMManual();
            a.specifications = 'No results found';
            this.data.push(a);
        }

        this.isLoading = false;
    } catch (e) {
      this.searchError(e);
    }
  }

    searchError(e?: Error | string): void {
        console.error(e);
        this.notificationSvc.postNotification(
          this.notificationSvc.notificationBuilder(
            'Error',
            'An error happened while searching, please try again later',
            StarbaseNotificationTypes.Error
          )
        );
  }

    ngOnDestroy() {
        if (this.dataLoadSubscription) {
            this.dataLoadSubscription.unsubscribe();
        }

        if (this.createQMSubscriber) {
            this.createQMSubscriber.unsubscribe();
        }

        if (this.qmUpdatedSubscription) {
          this.qmUpdatedSubscription.unsubscribe();
        }

        this.webSocketSvc.disconnectQMConnection();
    }

    enableUpdateModal(msg: string, confirmmsg?: string): Observable<boolean> {
      const m = new Observable<boolean>(obj => {
          const modal = new StarbaseModalOptions('QM Updated', msg, [
              new StarbaseModalButton('Continue', () => {
                  obj.next(true);
                  this.modalSvc.closeModal(confirmmsg);
              })
          ], StarbaseModalTypes.Warning);
          modal.dismissable = true;
          this.modalSvc.postModal(modal);
      });

      return m;
    }
}
